import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const BlockStyleThree = () => {
    return (
        <Fragment>
            <div className="block-style-three mb-45">
                <h6 className="sub-title mb-20">Tetang Kita</h6>
                <h2 className="sect-title mb-15">Sumbupulsa Lengkap, Cepat, Lancar</h2>
                <p>Memiliki beberapa fasilitas yang memudahkan dalam transaksi yang diutamakan adalah kepuasan pelanggan
                </p>
                <Link className="theme_btn mt-55" to="/about">More Details</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleThree